import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { AdditionalApi } from 'api';
import { SearchAdditionalQueryType } from 'types';

function useGetAll(query: SearchAdditionalQueryType, enabled = true) {
  return useAuthQuery(
    getQueryKeys([KEY]).list({ ...query }),
    () => AdditionalApi.getAll(query),
    {
      select: (data) => data.data,
      enabled,
    },
  );
}

export default useGetAll;
